import { NavLink } from '@festina-life/ui/actions'

import { generalRoutes } from '../../routing/generalRoutes'

type Props = {
  isinKey: string
  tenantId: string
}

export const FundLink = ({ isinKey, tenantId }: Props) => (
  <NavLink to={generalRoutes.tenant.fund({ tenantId, isinKey })}>
    {isinKey}
  </NavLink>
)
